<template>
    <div class="card card-custom gutter-b example example-compact">
        <div class="card-header">
            <h3 class="card-title">Tạo hợp đồng</h3>
        </div>
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form id="contract_create" class="form" @submit.prevent="handleSubmit(onSubmit)">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="d-bloc">Tìm học viên</label>
                                        <el-select ref="new_student"
                                                   v-model="student_id"
                                                   :loading="loading"
                                                   :remote-method="remoteMethod"
                                                   class="w-100"
                                                   clearable
                                                   filterable
                                                   placeholder="Nhập mã hv/ số điện thoại"
                                                   remote
                                                   reserve-keyword
                                                   @change="getUserById"
                                        >
                                            <template slot="empty" class="align-items-center justify-content-center">
                                                <div
                                                    v-if="new_phone.length > 0"
                                                    class="align-items-center justify-content-center el-select-dropdown__item hover cursor-pointer"
                                                    @click="createNewUser">
                                                    <div>
                                                        Không tìm thấy học viên ->
                                                        <span style="color: #00aff0">Tạo học viên mới</span>
                                                        <span><i class="fas fa-user-plus"
                                                                 style="color: #00aff0"></i></span>
                                                    </div>
                                                </div>
                                            </template>
                                            <el-option v-for="user in userSearch"
                                                       :key="user.id"
                                                       :label="user.id + 100000+  ' - ' + user.name + ' - ' + user.phone"
                                                       :value="user.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div v-if="showUser" class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Họ tên</label>
                                        <ValidationProvider v-slot="{ errors,classes }" name="Họ tên" rules="required"
                                                            vid="name">
                                            <input v-model="contract.user.name" :class="classes" :disabled="isDisable"
                                                   class="form-control"
                                                   placeholder="Họ tên"
                                                   type="text">
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block" data-field="name" data-validator="notEmpty">
                                                    {{ errors[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <ValidationProvider v-slot="{ errors,classes }" name="Email" rules="required"
                                                            vid="email">
                                            <input v-model="contract.user.email" :class="classes" :disabled="isDisable"
                                                   class="form-control"
                                                   placeholder="Email" type="email">
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block" data-field="email" data-validator="notEmpty">
                                                    {{ errors[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label ref="label_phone">Số điện thoại</label>
                                        <ValidationProvider v-slot="{ errors,classes }" name="Số điện thoại"
                                                            rules="required"
                                                            vid="phone">
                                            <input v-model="contract.user.phone" :class="classes"
                                                   :disabled="isDisable || disablePhone"
                                                   class="form-control"
                                                   placeholder="Số điện thoại"
                                                   type="number"
                                            >
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block" data-field="phone" data-validator="notEmpty">
                                                    {{ errors[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <ValidationProvider v-slot="{ errors,classes }" name="Ngày sinh"
                                                            rules="required" vid="birthday">
                                            <label class="d-block">Ngày sinh <span class="text-danger">*</span></label>
                                            <el-date-picker
                                                ref="birthday"
                                                v-model="contract.user.profile.birthday"
                                                :class="classes"
                                                class="w-100"
                                                format="yyyy-MM-dd"
                                                placeholder="Chọn ngày sinh"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                            >
                                            </el-date-picker>
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block" data-field="birthday"
                                                     data-validator="notEmpty">
                                                    {{ errors[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div v-if="is_show" class="col-md-6">
                                    <div class="form-group">
                                        <label ref="label_address">Căn cước công dân</label>
                                        <ValidationProvider v-slot="{ errors }"
                                                            :rules="{ required: false,regex: /^[0-9]{9}$|^[0-9]{12}$/ }"
                                                            name="Căn cước công dân"
                                                            vid="cccd">
                                            <el-input v-model="contract.user.profile.cccd" class="w-100" filterable
                                                      placeholder="Nhập căn cước công dân"></el-input>
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block" data-field="name" data-validator="notEmpty">
                                                    {{ errors[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div v-if="is_show" class="col-md-6">
                                    <div class="form-group">
                                        <label ref="label_address">Địa chỉ <span class="text-danger">*</span></label>
                                        <ValidationProvider v-slot="{ errors,classes }" name="Địa chỉ" rules="required"
                                                          vid="address">
                                        <input v-model="contract.user.profile.address" :class="classes"
                                               class="form-control"
                                               placeholder="Nhập địa chỉ" type="text">
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block" data-field="address"
                                                     data-validator="notEmpty">
                                                    {{ errors[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div v-if="is_show" class="col-md-6">
                                    <div class="form-group">
                                        <label>Chọn Trung tâm
                                            <span class="text-danger">*</span></label>
                                        <ValidationProvider v-slot="{ errors,classes }" name="Trung tâm"
                                                            rules="required" vid="center_id">
                                            <el-select
                                                id="course" v-model="contract.center_id"
                                                :class="classes"
                                                class="w-100"
                                                clearable
                                                filterable
                                                placeholder="Trung tâm"
                                                @change="setStateCenter"
                                            >
                                                <el-option v-for="item in centers" :key="item.id" :label="item.name"
                                                           :value="item.id"></el-option>
                                            </el-select>
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block" data-field="name" data-validator="notEmpty">
                                                    {{ errors[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div v-if="is_show" class="col-md-6">
                                    <div class="form-group">
                                        <label>Hình thức đóng học phí:<span class="text-danger"></span></label>
                                        <ValidationProvider v-slot="{ errors,classes }" name="Hình thức đóng học phí"
                                                            rules="required"
                                                            vid="tuitionPayment">
                                            <el-select v-model="contract.tuitionPayment" class="w-100"
                                                       placeholder="Hình thức đóng học phí"
                                                       @input="handleTuitionPayment">
                                                <el-option v-for="item in tuitionPayments" :key="item.id"
                                                           :label="item.name"
                                                           :value="item.id"></el-option>
                                            </el-select>
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block" data-field="name" data-validator="notEmpty">
                                                    {{ errors[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div v-if="is_show" class="col-md-6">
                                    <div class="form-group">
                                        <label>Chọn Chi nhánh
                                            <span class="text-danger">*</span></label>
                                        <ValidationProvider v-slot="{ errors,classes }" name="Chi nhánh"
                                                            rules="required"
                                                            vid="branch_id">
                                            <el-select
                                                id="course" v-model="contract.branch_id"
                                                :class="classes"
                                                class="w-100"
                                                clearable
                                                filterable
                                                placeholder="Chi nhánh"
                                                @change="setStateBranch"
                                            >
                                                <el-option v-for="item in branches" :key="item.id" :label="item.name"
                                                           :value="item.id">
                                                </el-option>
                                            </el-select>
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block" data-field="name" data-validator="notEmpty">
                                                    {{ errors[0] }}
                                                </div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div v-if="is_show" class="col-md-6">
                                    <div class="form-group">
                                        <label>Chọn người giới thiệu</label>
                                        <select-search-user v-model="contract.ma_gioi_thieu" :class="classes"
                                                            @selectChange="selectMGT"></select-search-user>
                                    </div>
                                </div>
                                <div v-if="is_show" class="col-md-6">
                                    <div class="form-group">
                                        <label>Chọn người tư vấn</label>
                                        <select-search-user v-model="contract.nguoi_tu_van" :class="classes" type="TVV"
                                                            @selectChange="selectNguoiTuVan"></select-search-user>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div v-if="has_user" class="col-md-6">
                                    <div class="form-group">
                                        <button :disabled="disableButtuon" class="btn btn-primary"
                                                @click="createNewStudent">Tạo học viên
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-if="is_show" class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <button
                                            :disabled="!canAddMoreCourse"
                                            class="btn btn-light-success"
                                            type="button"
                                            @click="addCourse"
                                        >
                                            <i class="flaticon2-plus mb-1"></i>
                                            Thêm khóa học
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <CourseClass v-for="(course_info,index) in contract.student_register_courses"
                                         v-if="is_show"
                                         :key="index"
                                         :branchs="branches"
                                         :center_classes="center_classes"
                                         :condition_courses="condition_courses"
                                         :contract="contract"
                                         :course_info="course_info"
                                         :courses="availableCourses"
                                         :index="index"
                                         :isLoadClass="isLoadClass"
                                         :is_create="true"
                                         @deleteCourse="deleteCourse"
                                         @selectClass="selectClass"
                                         @selectCourse="selectCourse"
                            >
                            </CourseClass>

                            <div v-if="showMainClassSelect" class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>
                                            Lớp học chính
                                            <span class="text-danger">*</span>
                                        </label>
                                        <ValidationProvider
                                            v-slot="{ errors, classes }"
                                            name="Lớp học chính"
                                            rules="required"
                                            vid="deposit_refunds.main_class_id"
                                        >
                                            <el-select
                                                v-model="contract.deposit_refunds.main_class_id"
                                                v-loading="mainClassLoading"
                                                :class="classes"
                                                class="w-100"
                                                clearable
                                                filterable
                                                placeholder="Chọn lớp học chính đã đăng ký"
                                            >
                                                <el-option
                                                    v-for="item in mainClassOptions"
                                                    :key="item.id"
                                                    :label="item.label"
                                                    :value="item.id"
                                                />
                                            </el-select>
                                            <div class="fv-plugins-message-container">
                                                <div class="fv-help-block">{{ errors[0] }}</div>
                                            </div>
                                            <small
                                                v-if="!mainClassLoading && mainClassOptions.length === 0"
                                                class="text-muted"
                                            >
                                                Học viên chưa có lớp học chính nào đã đăng ký.
                                            </small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>

                            <!-- Dịch vụ bảo hành -->
                            <WarrantySelect :center-id="contract.center_id" :services="warrantyServices"
                                :disabled="false" :selected-id="contract.service_id"
                                @selected="setSelectedWarrantyService" />
                        </div>
                        <div v-if="is_show" class="col-md-5">
                            <div class="card card-custom card-pd gutter-b example example-compact">
                                <div class="card-header">
                                    <h3 class="card-title">Khóa học đã chọn</h3>
                                </div>
                                <div class="card-body">
                                    <div v-if="coursePrice.length > 0" class="">
                                        <div v-for="(course_info,index) in contract.student_register_courses"
                                             :key="index" class="row mb-2">
                                            <div v-if="course_info.course_id" class="col-md-6">
                                                <span> {{ course_info.course && course_info.course.name }} </span>
                                            </div>
                                            <div v-if="course_info.course_id && !isCourseType77Contract"
                                                 class="col-md-6">
                                                <input v-model="coursePrice[index]"
                                                       class="form-control input-custom float-right py-2 px-1"
                                                       style="text-align: right; height: 34px;" type="number"
                                                       v-on:input="changeCoursePrice(index)">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-3">
                                        <div class="col-md-6">
                                            <strong>Tổng tiền :</strong>
                                        </div>
                                        <div class="col-md-6">
                                            <strong class="input-slug float-right px-3">{{
                                                    contract.total != 0 ? formatPrice(contract.total, 'đ') : '0đ'
                                                }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card card-custom card-bg gutter-b example example-compact">
                                <div class="card-header">
                                    <h3 class="card-title"><b>Chi tiết thanh toán</b></h3>
                                </div>
                                <div class="card-body py-5">
                                    <div class="row">
                                        <div class="col-6">
                                            <p>Danh sách khuyến mại:</p>
                                        </div>
                                        <div class="col-6 ">
                                            <a class="promotion-list float-right" href="javascript:"
                                               @click="showVouchers">
                                                <strong>Danh sách khuyến mãi</strong>
                                                <span class="promotion-count">{{ promotionTotal ?? 0 }}</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div v-for="(voucher,index) in vouchersForContract" :key="index" class="row">
                                        <div class="col-4">
                                            <p>Voucher {{ ++index }}:</p>
                                        </div>
                                        <div class="col-4">
                                          <span v-if="voucher.type !== 0" class="promotion-icon">

                                          </span>
                                            <span v-else class="promotion-icon">
                                          </span>
                                            <span v-if="voucher.type !== 0" class="promotion-list"><strong>{{'Quy đổi quà tặng - ' + voucher.name }}</strong></span>
                                            <span v-else class="promotion-list"><strong>{{ voucher.name }}</strong></span>
                                        </div>
                                        <div class="col-4">
                                            <strong v-if="voucher.unit === 1 " class="text-danger float-right">{{ voucher.value | toThousandFilter }}
                                                ₫</strong>
                                            <strong v-else class="text-danger float-right">{{ voucher.value }} %</strong>
                                        </div>
                                    </div>
                                   <!-- Gói dịch vụ bảo hành: -->
                                    <template v-if="isShowWarrantySummary">
                                        <div class="col-12 pb-2">
                                            <strong>Gói dịch vụ bảo hành</strong>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <div class="row">
                                                <div class="col-md-6 d-flex align-items-center">
                                                    <i class="el-icon-menu mr-2"></i>
                                                    <strong>{{ contract?.service?.name }}</strong>
                                                </div>
                                                <div class="col-md-6 text-right">
                                                    <strong>{{ warrantyServiceAmount | formatVND }}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="row mt-3">
                                        <div class="col-md-6">
                                            <p class=""><b>Tổng giá trị hợp đồng :</b></p>
                                        </div>
                                        <div class="col-md-6">
                                            <p class="float-right"><b>{{totalPriceContractWithService | toThousandFilter }} ₫</b></p>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-md-12">
                                            <p class=""><b>Giá khoá học sau khuyến mại :</b></p>
                                        </div>
                                        <div class="col-md-12">
                                            <ul class="ml-6">
                                                <li v-for="(course_info,index) in courseList" :key="index">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <div> {{ course_info.course.name }}</div>
                                                        <div class=" pl-2 my-1" style="width: 50%; border-radius: 6px;">
                                                            <money v-model="course_info.course_fee_discount_proxy"
                                                                   class="form-control"
                                                                   style="text-align: right;" v-bind="money"/>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                              <div class="row mt-3 ml-2" v-if="gift_select && gift_select.length">
                                <div class="col-md-3 col-12">
                                  <p class="mb-2">Quà tặng :</p>
                                </div>

                                <div class="col-md-9 col-12">
                                  <div
                                      v-for="gift in gift_select"
                                      :key="gift.id"
                                      class="d-flex align-items-center mb-2"
                                  >
                                    <div class="flex-grow-1">
                                      <b-button
                                          class="m-1 m-0 w-100 text-left"
                                          :id="`gift-${gift.id}`"
                                          v-b-toggle="`payment-gift-detail-${gift.id}`"
                                      >
                                        {{ gift.name }} <i class="fas fa-chevron-down"></i>
                                      </b-button>

                                      <b-collapse :id="`payment-gift-detail-${gift.id}`">
                                        <p v-html="gift.description" class="mt-2 pl-2 ml-3 font-weight-bold mb-0"></p>
                                      </b-collapse>
                                    </div>
                                  </div>
                                </div>
                              </div>
                                <hr class="mb-5" style="width: 90%; margin:auto">
                                <div v-if="contract.branch_id" class="card-body pt-0">
                                    <h5 class="card-title mb-3"><b>Cách thức thanh toán</b> <span
                                        class="text-danger">*</span></h5>
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label>Chọn cách thức thanh toán</label>

                                            <ValidationProvider v-slot="{ errors }" name="Cách thức thanh toán"
                                                                rules="required"
                                                                vid="method_payment_id">
                                                <div class="payment-method-group">
                                                    <div
                                                        v-for="item in methodPayment"
                                                        :key="item.id"
                                                        class="payment-option mb-2"
                                                    >
                                                        <div class="d-flex align-items-center" style="gap: 10px;">
                                                            <div class="payment-checkbox">
                                                                <el-checkbox
                                                                    v-model="contract.method_payment_id"
                                                                    :label="item.id"
                                                                    @change="handleChangeMethodPayment"
                                                                >
                                                                    {{ item.name }}
                                                                </el-checkbox>
                                                            </div>

                                                            <el-input
                                                                v-if="item.id === 3 && contract?.method_payment_id?.includes(3)"
                                                                v-model="inputPaymentAmount"
                                                                class="payment-input"
                                                                placeholder="Nhập số tiền thanh toán"
                                                            />
                                                        </div>

                                                        <div
                                                            v-if="item.id === 3 && contract?.method_payment_id?.includes(3) && totalPriceContractWithService > 0"
                                                            class="quick-amount-group d-flex flex-wrap align-items-center mt-2 ml-4"
                                                            style="gap: 6px;"
                                                        >
                                                            <button
                                                                v-for="opt in QUICK_PERCENT_OPTIONS"
                                                                :key="opt.percent"
                                                                type="button"
                                                                class="btn btn-sm d-flex align-items-center py-1 px-2"
                                                                :class="contract.payment_amount === getQuickAmount(opt.percent, totalPriceContractWithService) ? 'btn-primary text-white font-weight-bold' : 'btn-outline-secondary bg-white'"
                                                                style="font-size: 12px; border-radius: 6px; gap: 4px;"
                                                                @click="setQuickPaymentAmount(getQuickAmount(opt.percent, totalPriceContractWithService))"
                                                            >
                                                                <span>{{ opt.label }}</span>
                                                                <span>·</span>
                                                                <span>{{ getQuickAmount(opt.percent, totalPriceContractWithService) | toThousandFilter }} đ</span>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div
                                                        v-if="contract?.method_payment_id?.includes(ONEPAY_METHOD_ID)"
                                                        class="onepay-detail mt-3 pl-3"
                                                    >
                                                        <div class="form-group mb-3">
                                                            <div class="font-weight-bold mb-2">
                                                                MỤC ĐÍCH THANH TOÁN <span class="text-danger">*</span>
                                                            </div>
                                                            <div style="display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px;">
                                                                <label
                                                                    v-for="opt in visibleOnePayInstallmentOptions"
                                                                    :key="opt.value"
                                                                    class="d-flex align-items-center p-2 rounded border cursor-pointer mb-0"
                                                                    :class="contract.onepay_installment === opt.value ? 'border-primary bg-light-primary font-weight-bold' : 'border-light bg-white'"
                                                                    style="transition: all 0.2s;"
                                                                >
                                                                    <el-radio
                                                                        v-model="contract.onepay_installment"
                                                                        :label="opt.value"
                                                                        class="mb-0"
                                                                        @change="handleChangeMethodPayment"
                                                                    >
                                                                        {{ opt.label }}
                                                                    </el-radio>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div class="form-group mb-3">
                                                            <div class="font-weight-bold mb-2">
                                                                SỐ TIỀN KHÁCH HÀNG THANH TOÁN <span class="text-danger">*</span>
                                                            </div>

                                                            <div
                                                                v-if="totalPriceContractWithService > 0"
                                                                class="quick-amount-group d-flex flex-wrap align-items-center mb-2"
                                                                style="gap: 6px;"
                                                            >
                                                                <button
                                                                    v-for="opt in QUICK_PERCENT_OPTIONS"
                                                                    :key="opt.percent"
                                                                    type="button"
                                                                    class="btn btn-sm d-flex align-items-center py-1 px-2"
                                                                    :class="contract.onepay_amount === getQuickAmount(opt.percent, totalPriceContractWithService) ? 'btn-primary text-white font-weight-bold' : 'btn-outline-secondary bg-white'"
                                                                    style="font-size: 12px; border-radius: 6px; gap: 4px;"
                                                                    @click="setQuickOnepayAmount(getQuickAmount(opt.percent, totalPriceContractWithService))"
                                                                >
                                                                    <span>{{ opt.label }}</span>
                                                                    <span>·</span>
                                                                    <span>{{ getQuickAmount(opt.percent, totalPriceContractWithService) | toThousandFilter }} đ</span>
                                                                </button>
                                                            </div>

                                                            <el-input
                                                                v-model="inputOnepayAmount"
                                                                placeholder="Nhập số tiền"
                                                                class="payment-input"
                                                                type="text"
                                                            >
                                                                <template slot="append">đ</template>
                                                            </el-input>
                                                        </div>
                                                        <div v-if="onepayNotice" class="alert alert-warning py-2 px-3 mb-3 text-sm" style="font-size: 13px;">
                                                            <i class="el-icon-warning mr-1"></i>
                                                            <span>{{ onepayNotice }}</span>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-6 mb-2">
                                                                <div class="border rounded p-3 bg-white">
                                                                    <small class="text-muted d-block mb-1">Phí trả góp / phụ phí</small>
                                                                    <div class="font-weight-bold text-dark font-size-h6">
                                                                        {{ formatOnePayMoney(onepayInstallmentFee) }} đ
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-6 mb-2">
                                                                <div class="border border-primary rounded p-3 bg-light-primary">
                                                                    <small class="text-muted d-block mb-1">Tổng cần thanh toán</small>
                                                                    <div class="font-weight-bold font-size-h6 text-primary">
                                                                        {{ formatOnePayMoney(onepayCardAmount) }} đ
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fv-plugins-message-container">
                                                    <div class="fv-help-block" data-field="method_payment_id"
                                                         data-validator="notEmpty">
                                                        {{ errors[0] }}
                                                    </div>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div v-if="contract?.method_payment_id?.length" class="box-instruct">
                                        <h5 class="mb-4" style="font-weight: 600; color: black">Hướng dẫn thanh
                                            toán:</h5>
                                        <div v-if="[1, 2].some(id => contract?.method_payment_id?.includes(id))"
                                             class="mb-4"
                                             style="line-height: 2">
                                            <h5>- Thanh toán tiền mặt</h5>
                                            <span>Nộp học phí trực tiếp tại hệ thống Trung tâm {{
                                                    centerName
                                                }}</span><br>
                                            <span>Thời gian: từ 14h00 đến 21h00 các ngày từ thứ 2 tới thứ 7 hàng tuần (trừ ngày lễ, tết theo quy định Nhà nước).</span><br>
                                            <span>Khi đến văn phòng giao dịch thuộc văn phòng {{ centerName }} , học viên sẽ được nhân viên  hướng dẫn các bước thanh toán.</span>
                                            <hr style="width: 98%">
                                        </div>

                                        <div
                                            v-if="contract?.method_payment_id?.includes(ONEPAY_METHOD_ID)"
                                            class="mb-4"
                                            style="line-height: 2"
                                        >
                                            <h5>HƯỚNG DẪN THANH TOÁN ONEPAY</h5>
                                            <div>
                                                <strong>Bước 1.</strong> Nhận link thanh toán Onepay trên phiếu đăng ký học tập<br>
                                                Kiểm tra nội dung hóa đơn và chọn “I agreed with Terms and Conditions”, chọn CHECK OUT TO PAY để thực hiện thanh toán
                                            </div>
                                            <div class="mt-2">
                                                <strong>Bước 2.</strong> Nhập thông tin thẻ<br>
                                                Khách hàng điền thông tin thẻ và nhấn nút Process Payment để thực hiện thanh toán
                                            </div>
                                            <div class="mt-2">
                                                <strong>Lưu ý:</strong> Nếu thẻ có tham gia chương trình xác thực 3D-Secure thì sau khi nhập thông tin thẻ. Ngân hàng sẽ yêu cầu nhập thêm mật khẩu
                                            </div>
                                            <hr style="width: 98%">
                                        </div>

                                        <div v-if="contract?.method_payment_id?.includes(3) && ratioPayment">
                                            <h5>- Thanh toán chuyển khoản</h5>
                                            <div style="line-height: 2">
                                                <span>Bước 1: Chuyển khoản theo thông tin chi tiết {{ centerName }} cung cấp: </span>
                                                <span>Bạn có thể gửi mã QR này cho khách hàng:</span>

                                                <div class="mt-2">
                                                    <span>Bước 2: Hoàn tất thông tin sau tin nhắn xác nhận chuyển tiền</span><br>
                                                    <span>{{ centerName }} sẽ nhắn tin tới số điện thoại khách hàng cung cấp trong nội dung
                          chuyển khoản để xác nhận thông tin chuyển tiền muộn nhất trong vòng 4h
                          (theo giờ hành chính) sau khi nhận được tiền. Trường hợp không nhận được
                          tin nhắn, bạn vui lòng báo khách hàng vui lòng liên hệ qua tổng đài 1900 4782
                          để được xử lý.</span><br>
                                                    <span>{{ centerName }} không chịu trách nhiệm nếu trong quá trình chuyển khoản sai thông tin.
                          Trong một số tình huống cụ thể, khách hàng có thể nhờ phía Ngân hàng thực hiện
                          chuyển khoản hoặc Ngân hàng thụ hưởng của {{ centerName }} để kiểm tra đối chứng cần thiết. Ngay khi nhận được xác nhận từ Ngân hàng. {{
                                                            centerName
                                                        }} sẽ tiến hành thủ tục tiếp theo cho Khách hàng.</span><br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="is_show" class="card-footer">
                    <button class="btn btn-primary mr-2" type="submit">Đăng ký</button>
                </div>
            </form>
        </ValidationObserver>
        <b-button id="show-gift-list" v-b-modal.list-promotions hidden size="lg">Open Third Modal</b-button>
        <b-button v-b-modal.list-vouchers class="show-vouchers-list" hidden size="lg">Open Third Modal</b-button>
        <!-- Danh sách mã giảm giá -->
        <b-modal id="list-promotions" ref="modal-list-promotions" :centered="true" :scrollable="true" hide-footer noFade
                 size="lg" title="Danh sách quà tặng">
            <div v-for="(gift,index) in listGift" :key="index" class="mt-5 border border-primary"
                 style="backgroundImage : linear-gradient(to bottom, #DFEAFF,#FFFFFF) "
            >
                <list-gift-item
                    :gift="gift"
                    :gift-select="gift_select"
                    :id_promotion_disable="id_promotion_disable"
                    :list-promotions="vouchersForContract"
                    @cancelGift="cancelGift"
                    @pickGift="pickGift"
                    @pickPrice="setVoucherForContract"
                    @showPromotionDetail="showPromotionDetail"
                >
                </list-gift-item>
            </div>
            <b-button id="show-promotion-detail" v-b-modal.promotion-detail hidden size="sm">Open Third Modal</b-button>
        </b-modal>
        <!-- Danh sách voucher -->
        <b-modal id="list-vouchers" ref="modal-list-vouchers" :centered="true" :scrollable="true" hide-footer size="lg"
                 title="Danh sách voucher">
            <div class="mb-2 pb-2 ml-0 mr-0 w-100">
                <el-input v-model="keyword" class="w-100" clearable
                          placeholder="Nhập tên,id voucher, quà tặng" @input="queryByKeywordDebounced"></el-input>
            </div>
            <div v-if="allCode[FLASH_SALE]?.length">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình Flash sale</h1>
                <list-vouchers :allCode='allCode'
                               :colorCode="'#FF8C22'"
                               :id_voucher_disable="id_voucher_disable"
                               :loading_voucher="loading_voucher"
                               :type="FLASH_SALE"
                               :vouchers="allCode[FLASH_SALE]"
                               @setListVoucherForContract="setListVoucherForContract(FLASH_SALE)"
                               @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <div v-if="allCode[PERIODIC_PROMOTIONS]?.length" class="mt-5">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình định kỳ</h1>
                <list-vouchers :allCode='allCode'
                               :colorCode="'#1BC5BD'"
                               :id_voucher_disable="id_voucher_disable"
                               :loading_voucher="loading_voucher"
                               :type="PERIODIC_PROMOTIONS"
                               :vouchers="allCode[PERIODIC_PROMOTIONS]"
                               @setListVoucherForContract="setListVoucherForContract(PERIODIC_PROMOTIONS)"
                               @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <div v-if="allCode[SCHOOL_LINK]?.length" class="mt-5">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình liên kết trường</h1>
                <list-vouchers :allCode='allCode'
                               :colorCode="'#3343D0'"
                               :id_voucher_disable="id_voucher_disable"
                               :loading_voucher="loading_voucher"
                               :type="SCHOOL_LINK"
                               :vouchers="allCode[SCHOOL_LINK]"
                               @setListVoucherForContract="setListVoucherForContract(SCHOOL_LINK)"
                               @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <div v-if="allCode[OTHER_SCHOOL]?.length" class="mt-5">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình khác</h1>
                <list-vouchers :allCode='allCode'
                               :colorCode="'#D40000'"
                               :id_voucher_disable="id_voucher_disable"
                               :loading_voucher="loading_voucher"
                               :type="OTHER_SCHOOL"
                               :vouchers="allCode[OTHER_SCHOOL]"
                               @setListVoucherForContract="setListVoucherForContract(OTHER_SCHOOL)"
                               @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <div v-if="allCode[DIGITAL]?.length && +contract.branch_id_sale === digitalBranch" class="mt-5">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình Digital</h1>
                <list-vouchers :allCode='allCode'
                               :colorCode="'#0094ff'"
                               :id_voucher_disable="id_voucher_disable"
                               :loading_voucher="loading_voucher"
                               :type="DIGITAL"
                               :vouchers="allCode[DIGITAL]"
                               @setListVoucherForContract="setListVoucherForContract(DIGITAL)"
                               @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <div v-if="allCode[SUSPENSION]?.length" class="mt-5">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình bảo lưu</h1>
                <list-vouchers :allCode='allCode'
                               :colorCode="'#7C3AED'"
                               :id_voucher_disable="id_voucher_disable"
                               :loading_voucher="loading_voucher"
                               :type="SUSPENSION"
                               :vouchers="allCode[SUSPENSION]"
                               @setListVoucherForContract="setListVoucherForContract(SUSPENSION)"
                               @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <div v-if="allCode[LEARNING_GUARANTEE]?.length" class="mt-5">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình bảo hành</h1>
                <list-vouchers :allCode='allCode'
                               :colorCode="'#2563EB'"
                               :id_voucher_disable="id_voucher_disable"
                               :loading_voucher="loading_voucher"
                               :type="LEARNING_GUARANTEE"
                               :vouchers="allCode[LEARNING_GUARANTEE]"
                               @setListVoucherForContract="setListVoucherForContract(LEARNING_GUARANTEE)"
                               @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <b-button id="show-voucher-detail" v-b-modal.voucher-detail hidden size="sm">Open Third Modal</b-button>
        </b-modal>
        <!-- Chi tiết mã giảm giá -->
        <b-modal id="promotion-detail" ref="modal-promotion-detail" :centered="true" :scrollable="true" hide-footer
                 size="lg" title="Chi tiết quà tặng">
            <gift-detail :gift="gift_detail"></gift-detail>
        </b-modal>
        <!-- Chi tiết voucher -->
        <b-modal id="voucher-detail" ref="modal-promotion-detail" :centered="true" :scrollable="true" hide-footer
                 size="lg" title="Chi tiết voucher">
            <voucher-detail :voucher="voucher_detail"></voucher-detail>
        </b-modal>
    </div>
</template>
<script>
import CourseClass from "@/view/pages/business/CourseClass";
import ListVouchers from "@/view/pages/business/modal-contract/ListVouchers";
import ListPromotions from "@/view/pages/business/modal-contract/ListPromotions";
import PromotionDetail from "@/view/pages/business/modal-contract/PromotionDetail";
import GiftDetail from "@/view/pages/business/modal-contract/GiftDetail";
import VoucherDetail from "@/view/pages/business/modal-contract/VoucherDetail";
import {GET_USER} from '@/core/services/ajaxUrl';
import {
    GET_PROMOTIONS_BY_CONTRACT,
    GET_VOUCHERS_BY_CONTRACT,
    LIST_GIFT
} from "@/core/services/store/contract/promotions.module";
import {
    CREATE_CONTRACT,
    CREATE_NEW_USER_WHEN_CREATE_CONTRACT,
    LIST_WARRANTY_SERVICE,
} from "@/core/services/store/contract/contracts.module";
import {GET_REGISTER_COURSES_BY_USER} from "@/core/services/store/contract/student-register-course.module";
import {GET_USER_MAIN_CLASSES_DEPOSIT_REFUND} from "@/core/services/store/deposit-refund/depositRefund.module";
import {GET_USER_BY_ID, SEARCH_CUSTOMER_BY_OR_ID} from "@/core/services/store/user/users.module";
import '@/assets/sass/custom/tai-chinh/contractForm.scss';
import {GET_CLASSES} from "@/core/services/store/course/classes.module";
import {GET_COURSES} from "@/core/services/store/course/course.module";
import {GET_BRANCHES} from "@/core/services/store/center/branch.module";
import {GET_CENTERS} from "@/core/services/store/center/centers.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {GET_TUITION_PAYMENT} from "@/core/services/store/installment/installment.module";
import ErrorMessage from "@/view/pages/common/ErrorMessage";
import SelectSearchUser from "@/view/pages/common/SelectSearchUser";
import ListGift from "@/view/pages/business/modal-contract/ListGiftItem";
import ListGiftItem from "@/view/pages/business/modal-contract/ListGiftItem";
import {TYPE_GIFT, TYPE_VOUCHER} from "@/core/option/promotionOption";
import {CodeModel} from "@/view/pages/contracts/CodeModel/code";
import {DIGITAL, FLASH_SALE, OTHER_SCHOOL, PERIODIC_PROMOTIONS, SCHOOL_LINK} from "@/core/option/contractOption";
import {Money} from 'v-money';
import {LEARNING_GUARANTEE, SUSPENSION} from "../../../core/option/contractOption";
import {isWarrantyServiceCenter} from "@/core/config/center/centerOption";
import WarrantySelect from "./WarrantySelect.vue";
import {
    ONEPAY_METHOD_ID,
    ONEPAY_INSTALLMENT,
    getVisibleInstallmentOptions,
    calcOnePayInstallmentFee,
    calcOnePayCardAmount,
    getOnePayFeePercent,
    getOnePayNotice,
    buildPaymentOptionLabel,
} from "@/core/option/onePayOption";

const _ = require('lodash');

const LEGACY_WARRANTY_SERVICE = {
    id: null,
    name: "Chính sách bảo hành cũ",
    percent: 0,
    hideCost: true,
};

const COURSE_TYPE_FIXED_TOTAL = 77;
const FIXED_CONTRACT_TOTAL = 200000;
const MAX_COURSE_TYPE_77 = 2;

export default {
    components: {
        ListGiftItem,
        ListGift,
        CourseClass,
        VoucherDetail,
        ListVouchers,
        PromotionDetail,
        ListPromotions,
        SelectSearchUser,
        ErrorMessage,
        GiftDetail,
        Money,
        WarrantySelect,
    },
    name: "ContractCreate",
    data() {
        return {
            total_course: 0,
            classes: null,
            isLoadClass: false,
            is_show_user_detail: false,
            prefix: '',
            centerName: '',
            ratioPayment: [],
            inputPaymentAmount: '',
            QUICK_PERCENT_OPTIONS: [
                { label: 'Toàn bộ', percent: 1 },
                { label: '50%', percent: 0.5 },
                { label: '30%', percent: 0.3 }
            ],
            contract: {
                branch_id_sale: null,
                gift_id: [],
                center_id: '',
                payment_amount: 0,
                branch_id: '',
                user_id: '',
                nguoi_tu_van: '',
                ma_gioi_thieu: '',
                method_payment_id: [],
                payment_option: '',
                onepay_installment: 0,
                onepay_amount: null,
                onepay_card_amount: null,
                installments_number: null,
                student_register_courses: [
                    {
                        id: '',
                        contract_id: '',
                        course_id: '',
                        class_id: '',
                        course_fee: 0,
                        course_sale: '',
                        dang_ky_ho: '',
                        xac_nhan: 1,
                        waiting_status: '',
                        center_class: {
                            id: '',
                            course_id: '',
                            name: ''
                        },
                        course: {
                            id: '',
                            name: '',
                            fee: '',
                            sale: '',
                            course_type_id: '',
                        },
                    }
                ],
                user: {
                    name: '',
                    email: '',
                    phone: '',
                    profile: {
                        birthday: '',
                        address: '',
                        cccd: '',
                    }
                },
                tuitionPayment: '',
                service: null,
                service_id: null,
                service_total: 0,
                total: 0,
                total_after_voucher: 0,
                deposit_refunds: {
                    main_class_id: null,
                    main_class_name: "",
                },
            },
            money: {
                decimal: ',',
                thousands: ',',
                prefix: '',
                suffix: ' VNĐ',
                precision: 0,
                masked: false,
            },
            //Cache
            loading_voucher: false,
            centers: [],
            branches: [],
            userSearch: [],
            //
            center_classes: [],
            courses: [],
            is_show_promotions: false,
            is_nap_rut_form: false,
            title: '',
            student_id: '',
            new_phone: '',
            /* recalculate when action */
            recalculate: 1,
            recalculateSubTotal: 1,
            check_general: false,
            loading: false,
            disableButtuon: false,
            is_show: false,
            has_user: false,
            showUser: false,
            otpCode: '',
            countDown: '',
            qrCode: '',
            countDownTimer: 0,
            isDisable: false,
            disablePhone: false,
            gift_select: [],
            gift_detail: {},
            voucher_detail: {},
            /* list variable */
            promotions: [],
            listGift: [],
            vouchers: [],
            /* list variable of contract */
            promotionForContract: '',
            vouchersForContract: [],
            /* condition variable */
            id_promotion_disable: '',
            id_voucher_disable: [],
            condition_courses: [],
            courses_selected: [],
            /* calculate variable  */
            totalDiscountByVoucher: 0,
            totalValueOfVoucher: 0,
            totalDiscount: 0,
            /* nạp rút tặng quà */
            type: '',
            coursePrice: [],

            methodPayment: [
                {id: 1, name: 'Tiền mặt'},
                {id: 2, name: 'Quẹt thẻ'},
                {id: 3, name: 'Chuyển khoản'},
                {id: ONEPAY_METHOD_ID, name: 'OnePay'},
            ],
            ONEPAY_METHOD_ID,
            inputOnepayAmount: '',
            onepayInstallmentOptions: [
                {value: 0, label: 'Trả thẳng'},
                {value: 6, label: 'Trả góp trong 6 tháng'},
                {value: 9, label: 'Trả góp trong 9 tháng'},
                {value: 12, label: 'Trả góp trong 12 tháng'},
            ],
            tuitionPayments: [],
            numberCode: 0,
            allCode: {},
            SCHOOL_LINK: SCHOOL_LINK,
            FLASH_SALE: FLASH_SALE,
            PERIODIC_PROMOTIONS: PERIODIC_PROMOTIONS,
            OTHER_SCHOOL: OTHER_SCHOOL,
            DIGITAL: DIGITAL,
            SUSPENSION: SUSPENSION,
            LEARNING_GUARANTEE: LEARNING_GUARANTEE,
            digitalBranch: 182,
            branchs: [],
            keyword: '',
            warrantyServices: [],
            mainClassOptions: [],
            mainClassLoading: false,
        }
    },

    created() {
        this.queryByKeywordDebounced = _.debounce(this.getVouchers, 500);
    },
    computed: {
        totalPriceContractWithService() {
            return this.contract.total_after_voucher + this.warrantyServiceAmount;
        },
        warrantyServiceAmount() {
            if (!this.contract.service) {
                return 0;
            }

            const total = Number(this.contract.total) || 0;
            const percent = Number(
                this.contract.service.percent_price != null
                    ? this.contract.service.percent_price
                    : this.contract.service.percent
            ) || 0;

            return (total * percent) / 100;
        },
        warrantyNotDefault() {
            return this.contract.service_id;
        },
        isShowWarrantySummary() {
            return isWarrantyServiceCenter(this.contract.center_id) && this.warrantyNotDefault;
        },
        getUserUrl: function () {
            return GET_USER
        },
        total_pages() {
            return 1;
        },
        courseList() {
            const self = this;
            const totalContract = this.contract.total - this.totalDiscount;
            const totalCourseFeeDiscount = this.contract.student_register_courses.reduce((sum, item) => sum + item.course_fee_discount, 0);
            return this.contract.student_register_courses.map(course_info => ({
                ...course_info,
                get course_fee_discount_proxy() {
                    if (self.isWithdrawWithCourse || totalCourseFeeDiscount !== totalContract) {
                        let percent = parseInt(course_info.course_fee) / self.contract.total;
                        return parseInt(course_info.course_fee) - (percent) * self.totalDiscount;
                    } else {
                        return parseInt(course_info.course_fee_discount);
                    }
                },
                set course_fee_discount_proxy(val) {
                    course_info.course_fee_discount = val;
                }
            }));
        },
        promotionTotal() {
            let allType = [PERIODIC_PROMOTIONS, FLASH_SALE, SCHOOL_LINK, OTHER_SCHOOL, DIGITAL, LEARNING_GUARANTEE, SUSPENSION];
            let count = allType.reduce((total, typeOne) => {
                return total + (this.allCode[typeOne]?.reduce((subTotal, item) => subTotal + (item.type !== null ? 1 : 0), 0) || 0);
            }, 0);
            return count - (this.allCode[DIGITAL]?.length ?? 0);
        },
        isCourseType77Contract() {
            return this.contract.student_register_courses.some(
                (item) => item.course_id && this.isCourseType77(item)
            );
        },
        availableCourses() {
            let filtered = [];
            if (this.courses?.length) {
                const selected = this.contract.student_register_courses.filter((item) => item.course_id);
                const hasType77 = selected.some((item) => this.isCourseType77(item));
                const hasOther = selected.some((item) => item.course_id && !this.isCourseType77(item));

                if (hasType77) {
                    filtered = this.courses.filter((item) => this.isCourseType77(item));
                } else if (hasOther) {
                    filtered = this.courses.filter((item) => !this.isCourseType77(item));
                } else {
                    filtered = this.courses;
                }
            }
            return this.mergeSelectedCoursesIntoOptions(filtered);
        },
        type77SelectedCount() {
            return this.countType77Courses();
        },
        showMainClassSelect() {
            return this.isCourseType77Contract && this.type77SelectedCount >= 1;
        },
        canAddMoreCourse() {
            if (!this.isCourseType77Contract) {
                return true;
            }
            return (
                this.type77SelectedCount < MAX_COURSE_TYPE_77 &&
                this.contract.student_register_courses.length < MAX_COURSE_TYPE_77
            );
        },
        visibleOnePayInstallmentOptions() {
            return getVisibleInstallmentOptions(this.contract?.tuitionPayment);
        },
        onepayFeePercent() {
            return getOnePayFeePercent(
                this.contract?.onepay_installment,
                this.vouchersForContract,
                this.contract?.tuitionPayment
            );
        },
        onepayNotice() {
            return getOnePayNotice(this.contract?.onepay_installment, this.onepayFeePercent);
        },
        onepayInputAmount() {
            const raw = (this.inputOnepayAmount || '').toString().replace(/\./g, '').replace(/\D/g, '');
            const parsed = raw ? parseInt(raw, 10) : 0;
            return parsed || Number(this.contract?.onepay_amount) || 0;
        },
        onepayInstallmentFee() {
            if (!this.contract?.method_payment_id?.includes(this.ONEPAY_METHOD_ID)) return 0;
            return calcOnePayInstallmentFee(
                this.onepayInputAmount,
                this.onepayFeePercent
            );
        },
        onepayCardAmount() {
            if (!this.contract?.method_payment_id?.includes(this.ONEPAY_METHOD_ID)) return 0;
            return calcOnePayCardAmount(this.onepayInputAmount, this.onepayInstallmentFee);
        },
    },
    mounted() {
        this.getCenters()
        this.getBranches()
        this.clearForm();
        this.getCourses();
        this.getClasses();
        this.getPromotions();
        this.getTuitionPayments();
        this.is_nap_rut_form = false;
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý hợp đồng", route: 'contract-index'},
            {title: "Tạo hợp đồng"}
        ]);
    },
    watch: {
        inputPaymentAmount(val) {
            const raw = val.replace(/\./g, '').replace(/\D/g, '');
            this.contract.payment_amount = raw ? parseInt(raw) : 0;
        },
        inputOnepayAmount(val) {
            const raw = (val || '').toString().replace(/\./g, '').replace(/\D/g, '');
            this.contract.onepay_amount = raw ? parseInt(raw, 10) : 0;
            this.inputOnepayAmount = this.contract.onepay_amount
                ? this.contract.onepay_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                : '';
            this.syncOnePayFeeToContract();
        },
        'contract.payment_amount': {
            immediate: true,
            handler(val) {
                this.inputPaymentAmount = val ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '';
            }
        },
        'contract.onepay_amount': {
            immediate: true,
            handler(val) {
                this.inputOnepayAmount = val ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '';
                this.syncOnePayFeeToContract();
            }
        },
        vouchersForContract: {
            deep: true,
            handler() {
                this.syncOnePayFeeToContract();
            }
        },
        'contract.tuitionPayment'() {
            this.syncOnePayFeeToContract();
        },
        'contract.onepay_installment'() {
            this.syncOnePayFeeToContract();
        },
        recalculate() {
            if (this.isCourseType77Contract) {
                this.applyCourseType77Fees();
                this.contract.total = FIXED_CONTRACT_TOTAL;
            } else {
                this.contract.total = _.reduce(this.contract.student_register_courses, function (result, value) {
                    result += value.course_fee * (1 - value.course_sale / 100);
                    return result;
                }, 0);
            }
            this.recalculateSubTotal++;
        },
        recalculateSubTotal() {
            this.calculateTotalValueForVoucher();
            this.reloadTotalDiscount();
            if (this.contract.total - this.totalDiscount >= 0) {
                this.contract.total_after_voucher = this.contract.total - this.totalDiscount;
                this.contract.total_debt = this.contract.total_after_voucher;
                return;
            }
            this.vouchersForContract = [];
            this.totalDiscount = 0
            this.contract.total_after_voucher = this.contract.total;
            for (let key in this.allCode) {
                this.allCode[key].forEach((code) => {
                    code.selected = false;
                    code.isUseGift = code.type == this.isGift ? true : false
                });
            }
            this.$notify({
                title: 'Cảnh báo!',
                message: 'Áp dụng voucher không được âm tiền',
                type: 'warning'
            });
        },
        contract: {
            handler() {
                this.coursePrice = this.contract.student_register_courses.map((item) => item.course_fee);
                this.getPromotions();
                // this.getVouchers();
            },
            deep: true,
            immediate: true
        },
        'contract.center_id'(center_id) {
            if (isWarrantyServiceCenter(center_id)) {
                this.fetchWarrantyServices();
            } else {
                this.warrantyServices = [];
            }
        },
        isCourseType77Contract(hasType77) {
            if (!hasType77) {
                this.resetDepositRefund();
            } else if (this.contract.user_id) {
                this.fetchUserMainClasses();
            }
        },
        'contract.user_id'(userId) {
            if (userId && this.isCourseType77Contract) {
                this.fetchUserMainClasses();
            } else {
                this.mainClassOptions = [];
            }
        },
    },
    methods: {
        countType77Courses() {
            return this.contract.student_register_courses.filter(
                (item) => item.course_id && this.isCourseType77(item)
            ).length;
        },
        resetDepositRefund() {
            this.contract.deposit_refunds = {main_class_id: null, main_class_name: ""};
            this.mainClassOptions = [];
        },
        mapMainClassOption(item) {
            const classId = item.id ?? item.class_id ?? item.classes?.id ?? item.classroom_id;
            if (!classId) {
                return null;
            }
            if (item.label) {
                return {
                    id: classId,
                    label: item.label,
                    main_class_name: item.main_class_name ?? item.class_name ?? item.classes?.name ?? item.label,
                    student_register_course_id: item.student_register_course_id ?? null,
                };
            }
            const courseTypeId = Number(
                item.course?.course_type_id ?? item.course_type_id ?? item.course_type
            );
            if (courseTypeId === COURSE_TYPE_FIXED_TOTAL) {
                return null;
            }
            const className = item?.classes?.name ?? item.name ?? "";
            const courseName = item.course?.name ?? item.course_name ?? "";
            const label = className
                ? courseName
                    ? `${className} — ${courseName}`
                    : className
                : courseName || `Lớp #${className}`;
            return {
                id: classId,
                label,
                main_class_name: className || label,
                student_register_course_id: item.id ?? null,
            };
        },
        normalizeMainClassRows(data) {
            if (Array.isArray(data)) {
                return data;
            }
            if (Array.isArray(data?.data)) {
                return data.data;
            }
            return [];
        },
        async fetchUserMainClasses() {
            const userId = this.contract.user_id || this.contract.user?.id;
            if (!userId) {
                this.mainClassOptions = [];
                return;
            }
            this.mainClassLoading = true;
            try {
                let rows = [];
                try {
                    const res = await this.$store.dispatch(GET_USER_MAIN_CLASSES_DEPOSIT_REFUND, {
                        user_id: userId,
                    });
                    if (!res?.error) {
                        rows = this.normalizeMainClassRows(res?.data ?? res);
                    }
                } catch {
                    rows = [];
                }
                if (!rows.length) {
                    const fallback = await this.$store.dispatch(GET_REGISTER_COURSES_BY_USER, {
                        user_id: userId,
                    });
                    if (!fallback?.error) {
                        rows = this.normalizeMainClassRows(fallback?.data ?? fallback);
                    }
                }
                const seen = new Set();
                this.mainClassOptions = rows
                    .map((row) => this.mapMainClassOption(row))
                    .filter((opt) => {
                        if (!opt || seen.has(opt.id)) {
                            return false;
                        }
                        seen.add(opt.id);
                        return true;
                    });
                if (
                    this.contract.deposit_refunds.main_class_id &&
                    !this.mainClassOptions.some(
                        (opt) => opt.id === this.contract.deposit_refunds.main_class_id
                    )
                ) {
                    this.contract.deposit_refunds.main_class_id = null;
                    this.contract.deposit_refunds.main_class_name = "";
                }
            } finally {
                this.mainClassLoading = false;
            }
        },
        resolveCourseForItem(item) {
            if (!item) {
                return null;
            }
            if (item.course?.course_type_id != null) {
                return item.course;
            }
            const courseId = item.course_id;
            if (!courseId) {
                return item.course ?? null;
            }
            const fromList = (this.courses || []).find((course) => Number(course.id) === Number(courseId));
            return fromList ?? item.course ?? null;
        },
        mergeSelectedCoursesIntoOptions(options) {
            const merged = [...(options || [])];
            const ids = new Set(merged.map((course) => Number(course.id)));
            (this.contract.student_register_courses || []).forEach((item) => {
                if (!item?.course_id) {
                    return;
                }
                const course = this.resolveCourseForItem(item) || item.course;
                const id = Number(course?.id ?? item.course_id);
                if (!id || ids.has(id)) {
                    return;
                }
                const name = course?.name;
                if (!name) {
                    return;
                }
                merged.push({
                    id,
                    name,
                    fee: course.fee ?? item.course_fee,
                    sale: course.sale ?? item.course_sale,
                    course_type_id: course.course_type_id,
                });
                ids.add(id);
            });
            return merged;
        },
        isCourseType77(courseOrItem) {
            const course = courseOrItem?.course_id != null && courseOrItem?.course_type_id == null
                ? this.resolveCourseForItem(courseOrItem)
                : courseOrItem;
            return course && Number(course.course_type_id) === COURSE_TYPE_FIXED_TOTAL;
        },
        applyCourseType77Fees() {
            const type77Courses = this.contract.student_register_courses.filter(
                (item) => item.course_id && this.isCourseType77(item)
            );
            const count = type77Courses.length;
            if (!count) {
                return;
            }
            const perCourse = Math.floor(FIXED_CONTRACT_TOTAL / count);
            const remainder = FIXED_CONTRACT_TOTAL - perCourse * count;
            type77Courses.forEach((item, index) => {
                item.course_fee = perCourse + (index === 0 ? remainder : 0);
                item.fee = item.course_fee * (100 - (item.course_sale || 0)) / 100;
            });
        },
        async fetchWarrantyServices() {
            try {
                const response = await this.$store.dispatch(LIST_WARRANTY_SERVICE);
                const list = Array.isArray(response && response.data) ? response.data : [];
                this.warrantyServices = list.map((item) => ({
                    id: item.id,
                    name: item.name,
                    percent: Number(item.percent_price != null ? item.percent_price : 0),
                })).concat(LEGACY_WARRANTY_SERVICE);
            } catch (error) {
                this.warrantyServices = [];
            }
        },
        setSelectedWarrantyService(service) {
            const percent = Number(service?.percent_price ?? service?.percent ?? 0) || 0;
            const total = Number(this.total ?? this.contract?.total ?? 0) || 0;

            Object.assign(this.contract, {
                service: service ?? null,
                service_id: service?.id ?? null,
                service_total: service ? (total * percent) / 100 : 0,
            });
        },
        cancelGift(event) {
            // Chỉ gỡ đúng quà được hủy, giữ nguyên các quà khác của cùng chương trình
            this.removeGiftSelected(event.id);
            let index = this.getIndex(event);
            if (index == null) {
                return;
            }
            this.removeContractVoucher(index + 1);
        },
        removeGiftSelected(voucherId) {
            if (Array.isArray(this.contract.gift_id)) {
                this.contract.gift_id = this.contract.gift_id.filter((id) => +id !== +voucherId);
            }
            this.gift_select = (this.gift_select || []).filter((gift) => +gift.id !== +voucherId);
            this.contract.gift_select = this.gift_select.slice();
        },
        getIndex(event) {
            let index = null;
            for (let i = 0; i < this.vouchersForContract.length; i++) {
                let item = this.vouchersForContract[i];
                if (item.id === event.id) {
                    index = i;
                }
            }
            return index;
        },
        resetGift() {
            this.contract.gift_id = [];
            this.gift_select = [];
            this.contract.gift_select = [];
        },
        pickGift(event) {
            this.contract.gift_select.push(event);
            this.gift_select .push(event);
            this.contract.gift_id.push(event.id);
        },
        selectNguoiTuVan: function (value) {
            this.contract.nguoi_tu_van = value;
        },
        selectMGT: function (value, branch_id_sale) {
            this.contract.branch_id_sale = branch_id_sale;
            this.contract.ma_gioi_thieu = value;
        },
        remoteMethod: function (query) {
            if (query !== '' && query.length >= 6 && query.length <= 10) {
                this.new_phone = query;
                const params = {
                    search_customer_by_phoneOrId: query,
                    limit: 10000,
                    status: 1,
                    is_staff: 0,
                }
                this.loading = true;
                let vm = this;
                setTimeout(function () {
                    vm.getStudents(params);
                }, 300)
            } else {
                this.new_phone = '';
            }
        },
        createNewUser: function () {
            this.contract.user.phone = this.new_phone;
            this.student_id = this.new_phone;
            this.new_phone = '';
            this.has_user = true;
            this.isDisable = false;
            this.showUser = true;
            this.$refs.new_student.visible = false;
        },
        createNewStudent: function () {
            this.disableButtuon = true;
            this.$store.dispatch(CREATE_NEW_USER_WHEN_CREATE_CONTRACT, {
                phone: this.contract.user.phone,
                name: this.contract.user.name,
                email: this.contract.user.email,
                birthday: this.contract.user.profile.birthday,
            }).then((res) => {
                this.contract.user = res.data;
                this.isDisable = true;
                this.$notify({
                    title: 'Thành công',
                    message: 'Tạo học viên mới',
                    type: 'success'
                });
                this.is_show = true;
                this.has_user = false;
                this.contract.user_id = res.data.id;
                if (this.isCourseType77Contract) {
                    this.fetchUserMainClasses();
                }
            }).catch((error) => {
                if (error.data?.data?.message_validate_form) {
                    this.$refs.form.setErrors(error.data.data.message_validate_form);
                }
                if (error.data.message) {
                    this.$notify({
                        title: 'Thất bại',
                        message: error.data.message,
                        type: 'error'
                    });
                }
            }).finally(() => {
                this.disableButtuon = false;
            })
        },
        getStudents(params) {
            this.$store.dispatch(SEARCH_CUSTOMER_BY_OR_ID, params).then((res) => {
                this.userSearch = res.data.data;
                this.loading = false;
                if (res.data.data.length === 0) {
                    this.setContractUser();
                }
            })
        },
        getCenters() {
            this.$store.dispatch(GET_CENTERS, {
                limit: 10000,
                status: 1
            }).then((res) => {
                this.centers = res.data.data
            })
        },
        getBranches() {
            this.$store.dispatch(GET_BRANCHES, {
                limit: 10000,
                center_id: this.contract.center_id,
                status: 1,
                type: [2, 3]
            }).then((res) => {
                this.branches = res.data.data
            })
        },
        applyDefaultWarrantyService() {
            this.contract.service_id = 1;
        },
        resetWarrantyService() {
            Object.assign(this.contract, {
                service_id: null,
                service: null,
                service_total: 0,
            });
        },
        modifyService(center_id) {
            if (isWarrantyServiceCenter(center_id)) {
                this.applyDefaultWarrantyService();
            } else {
                this.resetWarrantyService();
            }
        },
        setStateCenter($event) {
            this.modifyService($event);
            this.contract.branch_id = '';
            this.branches = [];
            this.contract.center_id = $event;
            this.getBranches()
            this.getCourses()
            this.isLoadClass = !this.isLoadClass;
            this.getVouchers();

        },
        setStateBranch($event) {
            this.contract.branch_id = $event;
            this.getVouchers();
            this.getCourses();
            this.contract.method_payment_id = [];
            // this.getListGift();
        },
        handleTuitionPayment() {
            this.getListGift();
            this.getVouchers();
        },
        getUserById() {
            if (this.student_id) {
                this.$store.dispatch(GET_USER_BY_ID, this.student_id).then((res) => {
                    if (!res.error) {
                        this.contract.user = res.data;
                        this.isDisable = true;
                        if (this.contract.user.id != undefined) {
                            this.contract.user_id = this.contract.user.id
                        }
                        this.is_show_user_detail = true
                        this.has_user = false;
                        this.is_show = true;
                        this.showUser = true;
                        if (this.isCourseType77Contract) {
                            this.fetchUserMainClasses();
                        }
                    }
                });
            } else {
                this.setContractUser()
            }
        },
        setContractUser() {
            this.is_show = false
            this.contract.user = {
                name: '',
                email: '',
                phone: '',
                profile: {
                    birthday: ''
                }
            }
        },
        getClasses: function () {
            this.$store.dispatch(GET_CLASSES, {limit: 10000, status: 1}).then((res) => {
                this.center_classes = _.map(res.data.data, (item) => {
                    item = {id: item.id, name: item.name, course_id: item.course_id};
                    return item;
                })
            });
        },
        getCourses: function () {
            this.$store.dispatch(GET_COURSES, {
                limit: 10000,
                status: 1,
                center_id: this.contract.center_id,
                branch_id: this.contract.branch_id,
                all: 1,
                course_branch: 1
            }).then((res) => {
                this.courses = _.map(res.data, (item) => {
                    item = {
                        id: item.id,
                        name: item.name,
                        fee: item.fee,
                        sale: item.sale,
                        course_type_id: item.course_type_id
                    };
                    return item;
                })
                this.contract.student_register_courses = [];
            });
        },
        showGift() {
            if (!this.contract.center_id && !this.contract.branch_id) {
                this.$bvToast.toast('Bạn chưa chọn Trung tâm hoặc chi nhánh', {
                    title: 'Loading danh sách khuyến mại',
                    variant: 'danger',
                    solid: true
                });
                return;
            }
            document.getElementById('show-gift-list').click();
        },
        showVouchers() {
            $('.show-vouchers-list').click();
        },
        showPromotionDetail(promotion) {
            this.gift_detail = promotion;
            document.getElementById('show-promotion-detail').click();
        },
        showVoucherDetail(voucher) {
            this.voucher_detail = voucher;
            document.getElementById('show-voucher-detail').click();
        },
        setPromotionForContract(promotion) {
            this.recalculateSubTotal += 1;
            this.promotionForContract = promotion;
            this.id_promotion_disable = promotion.id;
            this.$notify({
                title: 'Thành công',
                message: 'Áp dụng mã khuyến mại thành công',
                type: 'success'
            });
            this.$refs['modal-list-promotions'].hide();
        },
        setVoucherForContract(voucher) {
            if (!voucher && !voucher.amount && voucher.amount != null) {
                this.$notify({
                    title: 'Không thành công',
                    message: 'Voucher đã hết lượt áp dụng',
                    type: 'error'
                });
                return
            }
            this.vouchersForContract.push(voucher);
            this.id_voucher_disable.push(voucher.id);
            this.recalculateSubTotal += 1;
            if (voucher.type === TYPE_GIFT) {
                // this.$notify({
                //   title: 'Thành công',
                //   message: 'Quy đổi quà tặng thành công',
                //   type: 'success'
                // });
            } else {
                // this.$notify({
                //   title: 'Thành công',
                //   message: 'Áp dụng voucher thành công',
                //   type: 'success'
                // });
            }
        },
        setListVoucherForContract(type) {
            let allType = [PERIODIC_PROMOTIONS, FLASH_SALE, SCHOOL_LINK, OTHER_SCHOOL, DIGITAL, LEARNING_GUARANTEE, SUSPENSION];
            this.vouchersForContract = [];
            this.id_voucher_disable = []
            this.resetGift()
            this.totalDiscount = 0
            this.contract.total_after_voucher = this.contract.total
            allType.forEach((typeOne) => {
                if (this.allCode[typeOne]) {
                    let checkIsType = this.allCode[typeOne].filter((code) => code.selected === true);
                    checkIsType.forEach((item) => {
                        if (item.isUseGift) {
                            this.pickGift(item);
                        } else {

                            this.setVoucherForContract(item);
                        }
                    });
                }
            });
        },
        removeContractPromotion(index) {
            this.promotionForContract = '';
            this.id_promotion_disable = '';
            this.recalculateSubTotal += 1;
            this.vouchersForContract.splice(index - 1, 1);
        },
        removeContractVoucher(index) {
            this.recalculateSubTotal += 1;
            this.vouchersForContract.splice(index - 1, 1);
            this.id_voucher_disable.splice(index - 1, 1);
        },
        clearForm() {
            this.title = '';
        },
        selectClass: function (param) {
            const studentRegisterCourse = this.contract.student_register_courses[param.index];
            studentRegisterCourse.class_id = param.class_id;
        },
        selectCourse: function (param) {
            this.resetGift();
            this.vouchersForContract = [];
            const course = this.courses.find(item => item.id === param.course_id);
            const studentRegisterCourse = this.contract.student_register_courses[param.index];
            const otherSelected = this.contract.student_register_courses.filter(
                (item, index) => index !== param.index && item.course_id
            );

            if (course && otherSelected.length) {
                const hasType77 = otherSelected.some((item) => this.isCourseType77(item));
                const selectingType77 = this.isCourseType77(course);

                if (hasType77 && !selectingType77) {
                    studentRegisterCourse.course_id = '';
                    this.$message.warning('Hợp đồng loại khóa này chỉ được chọn các khóa cùng loại');
                    return;
                }
                if (!hasType77 && selectingType77) {
                    studentRegisterCourse.course_id = '';
                    this.$message.warning('Không thể chọn khóa học này cùng với các khóa học khác loại');
                    return;
                }
            }

            if (course && this.isCourseType77(course)) {
                const otherType77Count = otherSelected.filter((item) =>
                    this.isCourseType77(item)
                ).length;
                if (otherType77Count >= MAX_COURSE_TYPE_77) {
                    studentRegisterCourse.course_id = '';
                    this.$message.warning(
                        `Chỉ được chọn tối đa ${MAX_COURSE_TYPE_77} khóa phí bổ trợ cấp tốc`
                    );
                    return;
                }
            }

            studentRegisterCourse.course_id = param.course_id;
            studentRegisterCourse.chi_nhanh_hoc = param.branch_id ?? this.contract.branch_id;
            let courseSelects = this.contract.student_register_courses
                .filter(item => item.course_id !== '')
                .map(item => item.course_id);
            if (courseSelects.filter((item) => item === param.course_id).length >= 2) {
                studentRegisterCourse.course_id = '';
                this.$message.warning('Bạn không thể chọn 2 khóa học trùng nhau trong cùng 1 hợp đồng');
            } else if (course) {
                studentRegisterCourse.course = course;
                studentRegisterCourse.course_id = course.id;
                studentRegisterCourse.course_sale = course.sale;
                if (this.isCourseType77(course)) {
                    studentRegisterCourse.course_fee = 0;
                    studentRegisterCourse.fee = 0;
                } else {
                    studentRegisterCourse.course_fee = course.fee;
                    studentRegisterCourse.fee = course.fee * (100 - course.sale) / 100;
                }
            }
            this.reloadConditionCourses();
            this.recalculate++;
            this.getListGift();
            this.getVouchers()
        },
        addCourse() {
            if (!this.canAddMoreCourse) {
                this.$message.warning(
                    `Chỉ được chọn tối đa ${MAX_COURSE_TYPE_77} khóa phí bổ trợ cấp tốc`
                );
                return;
            }
            this.contract.student_register_courses.push({
                contract_id: this.contract.id,
                course_id: '',
                class_id: '',
                course_fee: 0,
                course_sale: 0,
                dang_ky_ho: 0,
                xac_nhan: 1,
                waiting_status: '',
                fee: 0,
                status: 2,
                paid: 0,
                user_id: this.contract.user_id,
                center_id: this.contract.center_id,
                branch_id: this.contract.branch_id,
                center_class: {
                    id: '',
                    course_id: '',
                    name: ''
                },
                course: {
                    id: '',
                    name: '',
                    fee: '',
                    sale: '',
                    course_type_id: '',
                },
            })
        },
        deleteCourse(index) {
            this.recalculate++;
            if (this.contract.student_register_courses.length > 1) {
                this.contract.student_register_courses.splice(index, 1);
            } else {
                this.$message.warning('Hợp đồng phải có khóa học');
            }
            this.reloadConditionCourses();
            this.getListGift();
            this.getVouchers()
        },
        reloadConditionCourses() {
            this.condition_courses = _.reduce(this.contract.student_register_courses, function (result, value, key) {
                result.push(value.course);
                return result
            }, []);
        },
        calculateTotalValueForVoucher() {

            this.totalDiscountByVoucher = _.reduce(this.vouchersForContract, function (result, value, key) {
                if (value.unit === 0) {
                    result += value.value;
                }
                return result;
            }, 0);
            this.totalValueOfVoucher = _.reduce(this.vouchersForContract, function (result, value, key) {
                if (value.unit === 1) {
                    result += value.value;
                }
                return result;
            }, 0);
        },
        reloadTotalDiscount() {
            // let valuePromotion = this.promotionForContract ? this.promotionForContract.value : 0;
            this.totalDiscount = this.totalValueOfVoucher + (this.contract.total * this.totalDiscountByVoucher / 100);
        },
        changeCoursePrice(index) {
            if (this.isCourseType77Contract) {
                return;
            }
            this.contract.student_register_courses[index].fee = this.coursePrice[index];
            this.contract.student_register_courses[index].course_fee = this.coursePrice[index] * 100 / (100 - this.contract.student_register_courses[index].course_sale);
            this.recalculate++;
        },
        validatePeriodicGift() {
            let allCode = this.allCode || {};
            let giftSelected = Object.keys(allCode).reduce((result, key) => {
                let codes = allCode[key] || [];
                return result.concat(codes.filter((code) => code.selected && +code.type !== TYPE_VOUCHER));
            }, []);
            if (giftSelected.length > 1) {
                this.$message.warning('Chỉ được chọn 1 bộ quà');
                return false;
            }
            return true;
        },
        onSubmit() {
            if (!this.validatePeriodicGift()) {
                return;
            }
            if (this.showMainClassSelect && !this.contract.deposit_refunds?.main_class_id) {
                this.$message.warning('Vui lòng chọn lớp học chính');
                return;
            }
            if (this.showMainClassSelect) {
                const selectedMainClass = this.mainClassOptions.find(
                    (opt) => opt.id === this.contract.deposit_refunds.main_class_id
                );
                this.contract.deposit_refunds.main_class_name =
                    selectedMainClass?.main_class_name ?? selectedMainClass?.label ?? "";
            }
            this.contract.promotion_id = this.id_promotion_disable;
            this.contract.voucherIds = this.id_voucher_disable;
            if (this.id_promotion_disable) {
                this.id_voucher_disable.push(this.id_promotion_disable);
            }
            this.contract.student_register_courses.forEach((item) => {
                item.center_id = this.contract.center_id;
                item.branch_id = this.contract.branch_id;
            });
            this.contract.user_id = this.contract.user.id;
            if (!this.showMainClassSelect) {
                this.contract.deposit_refunds = null;
            }
            this.$store.dispatch(CREATE_CONTRACT, this.contract).then((res) => {
                this.$router.push({name: "contract-index"}).then(() => {
                    this.$notify({
                        title: 'Thành công',
                        message: res.message,
                        type: 'success'
                    });
                })
            }).catch((e) => {
                if (e.data?.data?.message_validate_form) {
                    this.$refs.form.setErrors(e.data.data.message_validate_form);
                }
            });
        },

        getVouchers() {
            this.$store.dispatch(GET_VOUCHERS_BY_CONTRACT, {
                center_id: this.contract.center_id,
                branch_id: this.contract.branch_id,
                quantity_course: this.contract?.student_register_courses?.map((course) => course.course_id).length,
                course_ids: this.contract?.student_register_courses?.map((course) => course.course_id) ?? [],
                tuition_payment_id: this.contract.tuitionPayment,
                keyword: this.keyword
            }).then((res) => {this.loading_voucher = false;
                this.vouchers = res.data;
                this.getListGift()
            });
        },
        getListGift() {
            this.listGift = [];
            if (this.contract.branch_id) {
                this.$store.dispatch(LIST_GIFT, {
                    'branch_id': this.contract.branch_id,
                    'quantity_course': this.getQuantityCourse(),
                    'tuition_payment_id': this.contract.tuitionPayment,'keyword': this.keyword,
                    course_ids: this.contract?.student_register_courses?.map((course) => course.course_id) ?? [],
                }).then((response) => {
                    this.listGift = response.data;
                    let giftModel = this.listGift.map((gift) => {
                        return new CodeModel(gift, PERIODIC_PROMOTIONS, true)
                    })
                    let voucherModel = this.vouchers?.map((voucher) => {
                        return new CodeModel(voucher, voucher.program_id)
                    })
                    let code = (voucherModel.concat(giftModel))
                    this.allCode = _.groupBy(code, ({typeCode}) => typeCode)
                });
            }
        },
        setGiftSelect(listGift) {
            let gift_id = this.contract.gift_id[0];
            for (let i = 0; i < listGift.length; i++) {
                if (listGift[i].id === gift_id) {
                    this.gift_select = listGift[i];
                }
            }
        },
        getQuantityCourse() {
            return this.total_course = this.contract.student_register_courses.filter((item) => {
                return item.course.id > 0;
            }).length;
        },
        getPromotions() {
            let courseIds = _.reduce(this.contract.student_register_courses, function (result, value, key) {
                result.push(value.course_id);
                return result;
            }, []);
            this.$store.dispatch(GET_PROMOTIONS_BY_CONTRACT, {
                courses: courseIds,
                center_id: this.contract.center_id,
                branch_id: this.contract.branch_id,
            }).then((res) => {
                this.promotions = res.data;
            });
        },
        getTuitionPayments() {
            this.$store.dispatch(GET_TUITION_PAYMENT).then((response) => {
                this.tuitionPayments = response.data
            });
        },
        async handleChangeMethodPayment() {
            if (!Array.isArray(this.contract?.method_payment_id)) {
                this.contract.method_payment_id = [];
            }
            this.prefix = this.contract.center_id === 295 ? 'EC' : 'IE';
            this.centerName = this.prefix == 'EC' ? 'ECoach' : 'IELTS Mentor';

            if (Number(this.contract?.tuitionPayment) !== 2 && this.contract?.onepay_installment !== 0) {
                this.contract.onepay_installment = 0;
            }

            this.contract.payment_option = buildPaymentOptionLabel(
                this.contract?.method_payment_id,
                this.methodPayment,
                this.contract?.onepay_installment
            );

            if (!this.contract.method_payment_id.includes(3)) {
                this.contract.payment_amount = '';
                this.inputPaymentAmount = '';
            }

            if (!this.contract.method_payment_id.includes(this.ONEPAY_METHOD_ID)) {
                this.contract.onepay_installment = null;
                this.contract.onepay_amount = null;
                this.contract.onepay_card_amount = null;
                this.contract.installments_number = null;
                this.inputOnepayAmount = '';
            } else {
                if (this.contract.onepay_installment == null || this.contract.onepay_installment === '') {
                    this.contract.onepay_installment = 0;
                }
                this.syncOnePayFeeToContract();
            }
        },
        syncOnePayFeeToContract() {
            if (!this.contract?.method_payment_id?.includes(this.ONEPAY_METHOD_ID)) {
                this.contract.onepay_card_amount = null;
                this.contract.installments_number = null;
                return;
            }
            if (Number(this.contract?.tuitionPayment) !== 2 && this.contract?.onepay_installment !== 0) {
                this.contract.onepay_installment = 0;
            }
            this.contract.onepay_amount = this.onepayInputAmount;
            this.contract.onepay_card_amount = this.onepayCardAmount;
            this.contract.installments_number = this.onepayFeePercent;
            this.contract.payment_option = buildPaymentOptionLabel(
                this.contract?.method_payment_id,
                this.methodPayment,
                this.contract?.onepay_installment
            );
        },
        formatOnePayMoney(amount) {
            const num = Number(amount) || 0;
            return num.toLocaleString('vi-VN');
        },
        getQuickAmount(percent, total) {
            return Math.round((Number(total) || 0) * percent);
        },
        setQuickPaymentAmount(amount) {
            this.contract.payment_amount = amount;
            this.inputPaymentAmount = amount ? amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '';
        },
        setQuickOnepayAmount(amount) {
            this.contract.onepay_amount = amount;
            this.inputOnepayAmount = amount ? amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '';
            this.syncOnePayFeeToContract();
        }
    },
}
</script>
<style>
a.disable {
    pointer-events: none;
    cursor: default;
    color: #FFFFFF;
    background-color: #8c8ea4;
}

.float-right {
    float: right;
}

.onepay-detail {
    border-left: 3px solid #409EFF;
    background: #f8fbff;
    padding: 12px 16px;
    border-radius: 0 6px 6px 0;
}
</style>
